
import { Product } from './types';

export const PRODUCTS: Product[] = [
  // --- Amazon Affiliate Products (queenof-21) ---
  {
    id: 'amz1',
    name: "Scrub Daddy Colours - FlexTexture Scrubber",
    category: 'Cleaning Tools',
    price: 9.99,
    description: "The viral sensation! Changes texture based on water temperature. Firm in cold water for tough scrubbing, soft in warm water for light cleaning.",
    image: 'https://m.media-amazon.com/images/I/71Y7Xy7NclL._AC_SL1500_.jpg',
    rating: 4.9,
    reviewCount: 45000,
    tags: ['Amazon Choice', 'Viral'],
    url: 'https://www.amazon.co.uk/Scrub-Daddy-Colours-FlexTexture-Scrubber/dp/B079V6D6PF?tag=queenof-21',
    inStock: true
  },
  {
    id: 'amz2',
    name: "The Pink Stuff - The Miracle Cleaning Paste",
    category: 'Cleaning Solutions',
    price: 5.95,
    description: "A versatile, specially formulated vegetable oil based soft scoop paste for use both inside and outside the home.",
    image: 'https://m.media-amazon.com/images/I/71X8uP-T+NL._AC_SL1500_.jpg',
    rating: 4.8,
    reviewCount: 120000,
    tags: ['Bestseller', 'Miracle Worker'],
    url: 'https://www.amazon.co.uk/Pink-Stuff-Miracle-Cleaning-Paste/dp/B00DU5SR9G?tag=queenof-21',
    inStock: true
  },
  {
    id: 'amz3',
    name: "Method All-Purpose Surface Cleaner - French Lavender",
    category: 'Cleaning Solutions',
    price: 3.00,
    description: "Naturally derived, biodegradable ingredients that pack a powerful cleaning punch. Leaves a delightful lavender scent.",
    image: 'https://m.media-amazon.com/images/I/61NfXpBvSXL._AC_SL1500_.jpg',
    rating: 4.7,
    reviewCount: 8500,
    tags: ['Eco-Friendly', 'Plant-Based'],
    url: 'https://www.amazon.co.uk/Method-Purpose-Surface-Cleaner-Lavender/dp/B008677X8G?tag=queenof-21',
    inStock: true
  },
  {
    id: 'amz4',
    name: "Zoflora Concentrated Disinfectant - Linen Fresh",
    category: 'Cleaning Solutions',
    price: 6.50,
    description: "Kills 99.9% of bacteria and viruses. A versatile 3-in-1 concentrated disinfectant that eliminates odours.",
    image: 'https://m.media-amazon.com/images/I/81I-uF0pHSL._AC_SL1500_.jpg',
    rating: 4.9,
    reviewCount: 15000,
    tags: ['Disinfectant', 'Long Lasting'],
    url: 'https://www.amazon.co.uk/Zoflora-Concentrated-Disinfectant-Linen-Fresh/dp/B07MMTGYV8?tag=queenof-21',
    inStock: true
  },
  {
    id: 'amz5',
    name: "Amazon Basics Microfibre Cleaning Cloths (24-Pack)",
    category: 'Cleaning Tools',
    price: 13.49,
    description: "Ultra-soft, non-abrasive microfibre cloths that won't scratch paints or other surfaces. Perfect for dusting and polishing.",
    image: 'https://m.media-amazon.com/images/I/81+p+hO8u0L._AC_SL1500_.jpg',
    rating: 4.7,
    reviewCount: 250000,
    tags: ['Bulk Buy', 'Essential'],
    url: 'https://www.amazon.co.uk/AmazonBasics-Microfibre-Cleaning-Cloths-Pack/dp/B009FUF6DM?tag=queenof-21',
    inStock: true
  },

  // --- Original Swan Range ---
  {
    id: 'p1',
    name: "Cordless Handheld Vacuum",
    category: 'Cordless Vacuum Cleaners',
    price: 79.99,
    description: "Compact and powerful handheld vacuum for quick clean-ups around the home and car.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052416436-YJ26NQD0W8GZ6474VC5Q/fit.webp?format=500w',
    rating: 4.8,
    reviewCount: 152,
    tags: ['Cordless', 'Compact'],
    url: 'https://shop.swan-brand.co.uk/cordless-vacuum-cleaners/lynseys-cleaning-range-cordless-handheld-vacuum',
    inStock: true
  },
  {
    id: 'p2',
    name: "1.3 Litre Spot Cleaner",
    category: 'Upright Vacuum Cleaners',
    price: 119.99,
    description: "Targeted spot cleaning for carpets and upholstery. Effortlessly lifts tough stains.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052942117-N2OOGAM1ABOCJ65KANRZ/fit+%281%29.webp?format=750w',
    rating: 4.9,
    reviewCount: 89,
    tags: ['Stain Specialist'],
    url: 'https://shop.swan-brand.co.uk/upright-vacuum-cleaners/lynseys-cleaning-range-spot-cleaner',
    inStock: true
  },
  {
    id: 'p3',
    name: "Cordless Window Vacuum",
    category: 'Cordless Vacuum Cleaners',
    price: 49.99,
    description: "Streak-free finish for windows, mirrors, and shower screens. Lightweight and easy to use.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052942107-XYMYYJ9LSDLYN82UZPTU/fit+%282%29.webp?format=750w',
    rating: 4.7,
    reviewCount: 64,
    tags: ['Streak-Free'],
    url: 'https://shop.swan-brand.co.uk/cordless-vacuum-cleaners/lynseys-cleaning-range-cordless-window-vacuum',
    inStock: true
  },
  {
    id: 'p4',
    name: "29.6V Cordless Anti-Tangle Vacuum",
    category: 'Cordless Vacuum Cleaners',
    price: 179.99,
    description: "Advanced anti-tangle technology makes this the perfect choice for pet owners and long hair.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052943177-46GUZNR52SNHB56B6YUA/fit+%283%29.webp?format=750w',
    rating: 4.9,
    reviewCount: 215,
    tags: ['Anti-Tangle', 'Pet Friendly'],
    url: 'https://shop.swan-brand.co.uk/cordless-vacuum-cleaners/lynseys-cleaning-range-296v-cordless-anti-tangle-vacuum',
    inStock: true
  },
  {
    id: 'p10',
    name: "Collapsible Laundry Basket",
    category: 'Laundry Baskets',
    price: 24.99,
    description: "Space-saving design that folds flat. Durable construction with comfortable handles.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052947603-A56YVMY51R79G6ZZZS11/fit+%2815%29.webp?format=750w',
    rating: 4.9,
    reviewCount: 421,
    tags: ['Space Saving'],
    url: 'https://shop.swan-brand.co.uk/laundry-baskets/lynseys-cleaning-range-collapsible-laundry-basket',
    inStock: true
  },
  {
    id: 'p12',
    name: "Spin Mop",
    category: 'Floor Cleaners',
    price: 29.99,
    description: "Efficient spinning action to clean floors effortlessly. Dual bucket system for clean and dirty water.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052946582-GB41TUCSSE7EAURLR2PK/fit+%2817%29.webp?format=750w',
    rating: 4.7,
    reviewCount: 156,
    tags: ['Dual Bucket', 'Microfibre'],
    url: 'https://shop.swan-brand.co.uk/floor-cleaners/lynseys-cleaning-range-spin-mop',
    inStock: true
  },
  {
    id: 'p25',
    name: "5 in 1 Spin Scrubber",
    category: 'Cleaning',
    price: 24.99,
    description: "Takes the elbow grease out of scrubbing. 5 interchangeable heads for bathroom, kitchen and more.",
    image: 'https://images.squarespace-cdn.com/content/v1/6962244a930d3931ee04d503/1768052948716-PZI6SRINGHGV2CGNG9BZ/fit+%2813%29.webp?format=750w',
    rating: 4.7,
    reviewCount: 79,
    tags: ['Versatile', 'Power Scrubber'],
    url: 'https://shop.swan-brand.co.uk/cleaning/lynseys-cleaning-range-5-in-1-spin-scrubber',
    inStock: true
  }
];

export const CATEGORIES: string[] = [
  'All',
  'Cleaning Tools',
  'Cleaning Solutions',
  'Cordless Vacuum Cleaners',
  'Floor Cleaners',
  'Laundry Baskets'
];
